import { TenantShippingProviderConfig } from "../../Models/TenantShippingProviderConfig";
import api from "../axios";

export const tenantShippingProviderConfigService = {
  getPublicCorreios: async (): Promise<TenantShippingProviderConfig> => {
    const response = await api.get("/tenant-shipping-provider-config/public/correios");
    return response.data;
  }
};
